import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IPenthouseTagType = 'advanced-dwellingStatus-penthouse';

export interface IPenthouseTag {
  type: 'advanced-dwellingStatus-penthouse';
}

function isPenthouseTag(tag: TTag): tag is IPenthouseTag {
  return tag.type === IPenthouseTagType;
}

export const penthouseTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const value = jsonQuery.penthouse && jsonQuery.penthouse.value;

    if (value !== undefined) {
      return ensureSingleTagExists(tags, isPenthouseTag, () => ({ type: IPenthouseTagType, value }));
    } else {
      return ensureTagNotExists(tags, isPenthouseTag);
    }
  },
};
